import { Component } from '@angular/core';

@Component({
  selector: 'default-slider',
  templateUrl: './slider.component.html',
  styleUrls: []
})
export class SliderComponent {
}
